import { render, staticRenderFns } from "./transferRecord.vue?vue&type=template&id=f6b285ba&scoped=true"
import script from "./transferRecord.vue?vue&type=script&lang=js"
export * from "./transferRecord.vue?vue&type=script&lang=js"
import style0 from "./transferRecord.vue?vue&type=style&index=0&id=f6b285ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b285ba",
  null
  
)

export default component.exports